/**
 * Automatic stone patterns (preset builder logic) above Thinkspace Group 1–N.
 *
 * UX
 *   • Full-width "Stone Pattern" stepper sits above Group pickers
 *   • Cycling a pattern writes into Group 1–N via Thinkspace controller
 *     (host.__w / __wiz) — no color-popover clicking
 *   • Stock Group pickers stay visible so shoppers can tweak after
 *
 * Data
 *   • School accents: __SJ_GEM_CONFIG__.accentGemColors (+ name fallbacks)
 *   • Pattern maps: assets/sj-stone-maps.js (shared with preset builder)
 *
 * Depends on: sj-stone-maps.js, sj-3d-builder.js, Thinkspace SJ patch (__w/__wiz)
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  var SM = window.SjStoneMaps;
  if (!B || !SM) return;

  var HOST_ATTR = 'data-sj-gem-panel';

  var DEFAULT_GEMS = [
    { label: 'White', value: 'white', hex: '#FFFFFF' },
    { label: 'Ruby', value: 'ruby', hex: '#9C131E' },
    { label: 'Garnet', value: 'garnet', hex: '#7F0000' },
    { label: 'Blue', value: 'blue', hex: '#0F52BA' },
    { label: 'Green', value: 'green', hex: '#008000' },
    { label: 'Black', value: 'black', hex: '#000000' },
    { label: 'Orange', value: 'orange', hex: '#FFA500' },
    { label: 'Yellow', value: 'yellow', hex: '#FFD700' },
    { label: 'Purple', value: 'purple', hex: '#800080' },
  ];

  var SVG_PREV =
    '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 4.5L7 10l5.5 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_NEXT =
    '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 4.5L13 10l-5.5 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* -------------------------------------------------------------------------- */
  /* Catalog / school accents                                                   */
  /* -------------------------------------------------------------------------- */

  function gemCatalog() {
    var list = B.gemConfig().gemstoneColors;
    return Array.isArray(list) && list.length ? list : DEFAULT_GEMS;
  }

  function gemLabel(value) {
    var g = gemCatalog().find(function (x) {
      return x.value === value;
    });
    return (g && g.label) || value;
  }

  function normalizeGemColor(raw) {
    var s = String(raw || '')
      .toLowerCase()
      .trim()
      .replace(/[_-]+/g, ' ');
    if (!s) return '';
    if (s === 'white' || s.indexOf('diamond') !== -1 || s.indexOf('clear') !== -1) {
      return s === 'white' ? 'white' : '';
    }
    var exact = gemCatalog().find(function (g) {
      return g.value === s || String(g.label || '').toLowerCase() === s;
    });
    if (exact) return exact.value;
    if (/purple|violet|lavender|amethyst/.test(s)) return 'purple';
    if (/garnet/.test(s)) return 'garnet';
    if (/ruby|scarlet|crimson|maroon|cardinal|\bred\b/.test(s)) return 'ruby';
    if (/emerald|green/.test(s)) return 'green';
    if (/sapphire|blue/.test(s)) return 'blue';
    if (/orange|burnt/.test(s)) return 'orange';
    if (/yellow|citrine|gold stone/.test(s)) return 'yellow';
    if (/black|onyx/.test(s)) return 'black';
    if (/white/.test(s)) return 'white';
    return '';
  }

  function normalizeAccentList(raw) {
    var list = Array.isArray(raw) ? raw : raw != null && raw !== '' ? [raw] : [];
    var out = [];
    list.forEach(function (item) {
      var token =
        typeof item === 'string'
          ? item
          : (item && (item.value || item.label || item.name)) || '';
      String(token)
        .split(/[,/&+|]+/)
        .forEach(function (part) {
          var n = normalizeGemColor(part);
          if (n && n !== 'white' && out.indexOf(n) === -1) out.push(n);
        });
    });
    return out;
  }

  function accentsFromSchoolName(name) {
    var s = String(name || '').toLowerCase();
    if (s.indexOf('baylor') !== -1) return ['green', 'yellow'];
    if (s.indexOf('tarleton') !== -1) return ['purple'];
    if (s.indexOf('james madison') !== -1 || s.indexOf('jmu') !== -1) {
      return ['purple'];
    }
    if (s.indexOf('lamar') !== -1) return ['ruby'];
    if (s.indexOf('texas tech') !== -1) return ['ruby'];
    if (
      s.indexOf('texas state') !== -1 ||
      s.indexOf('txst') !== -1 ||
      s.indexOf('southwest texas') !== -1
    ) {
      return ['ruby'];
    }
    if (s.indexOf('a&m') !== -1 || s.indexOf('texas a') !== -1) return ['ruby'];
    if (s.indexOf('utsa') !== -1 || s.indexOf('san antonio') !== -1) {
      return ['orange'];
    }
    if (s.indexOf('utrgv') !== -1 || s.indexOf('rio grande') !== -1) {
      return ['orange', 'green'];
    }
    if (s.indexOf('ole miss') !== -1 || s.indexOf('mississippi') !== -1) {
      return ['blue'];
    }
    if (s.indexOf('incarnate') !== -1 || s.indexOf('uiw') !== -1) {
      return ['ruby'];
    }
    return [];
  }

  function schoolName() {
    var fromCfg = B.gemConfig().schoolName;
    if (fromCfg) return String(fromCfg);
    var schoolSelect = document.querySelector('[data-option="School"] select');
    if (schoolSelect && schoolSelect.value) return schoolSelect.value;
    var widget = document.querySelector('x-3d-product-options[data-school-name]');
    return widget ? widget.getAttribute('data-school-name') || '' : '';
  }

  function schoolAccents() {
    var name = schoolName();
    if (window.SJSchoolColors) {
      var fromSheet = normalizeAccentList(window.SJSchoolColors.lookup(name));
      if (fromSheet.length) return fromSheet;
    }
    var fromCfg = normalizeAccentList(B.gemConfig().accentGemColors);
    if (fromCfg.length) return fromCfg;
    return accentsFromSchoolName(name);
  }

  /* -------------------------------------------------------------------------- */
  /* Style / size → gem map key                                                 */
  /* -------------------------------------------------------------------------- */

  function selectValue(optionName) {
    var field = document.querySelector('[data-option="' + optionName + '"]');
    if (!field) return '';
    var select = field.querySelector('select');
    if (select && select.value) return String(select.value).trim();
    var checked = field.querySelector('input[type="radio"]:checked');
    if (checked) return String(checked.value || '').trim();
    return String(field.getAttribute('data-value') || '').trim();
  }

  // Wizard only mounts the current step, so Ring Style / Seal Size are gone
  // on Stone. Read Thinkspace controller first.
  function currentTopCode() {
    var w = B.controller();
    var item = w && w.part1Item;
    var fromCtl = String(
      (item && item.value) || (w && w.selectedPart1Code) || ''
    ).replace(/F$/i, '');
    if (fromCtl) return fromCtl;
    return (
      selectValue('Ring Style') ||
      selectValue('Pendant Style') ||
      ''
    ).replace(/F$/i, '');
  }

  function currentShapeLetter() {
    var w = B.controller();
    var shape = w && w.shape;
    var fromCtl = shape && String(shape.value || '').toUpperCase();
    if (fromCtl === 'N' || fromCtl === 'E' || fromCtl === 'L') return fromCtl;
    var v = selectValue('Seal Size').toUpperCase();
    if (v === 'N' || v === 'E' || v === 'L') return v;
    if (/12\s*[x×]\s*10|elongat/i.test(v)) return 'L';
    if (/12|large/i.test(v)) return 'E';
    if (/10|small/i.test(v)) return 'N';
    var field = document.querySelector('[data-option="Seal Size"]');
    var dv = field && field.getAttribute('data-value');
    if (dv === 'N' || dv === 'E' || dv === 'L') return dv;
    return 'N';
  }

  function gemMapKey() {
    return SM.gemMapKey(currentTopCode(), currentShapeLetter());
  }

  function isFourCornerX(top) {
    return SM.isFourCornerX(top || currentTopCode());
  }

  /* -------------------------------------------------------------------------- */
  /* Pattern → G1–G4 (shared maps)                                              */
  /* -------------------------------------------------------------------------- */

  function gemsForPattern(kind, colorA, colorB) {
    return SM.gemsForPattern(kind, colorA, colorB, {
      topCode: currentTopCode(),
      shapeCode: currentShapeLetter(),
    });
  }

  function buildPatterns(accents) {
    var list = Array.isArray(accents) ? accents.filter(Boolean) : [];
    var patterns = [
      {
        id: 'all_white',
        label: 'All White',
        gems: gemsForPattern('all_white'),
      },
    ];
    var top = String(currentTopCode() || '').replace(/F$/i, '');
    var is177 = top === '177';
    var fourX = isFourCornerX(top);
    var groupCount = groupFields().length;
    if (!groupCount) return patterns;

    list.forEach(function (accent) {
      var label = gemLabel(accent);
      patterns.push({
        id: 'all_' + accent,
        label: 'All ' + label,
        gems: gemsForPattern('all', accent),
      });

      if (is177) {
        patterns.push({
          id: 'pinwheel_' + accent,
          label: 'Pinwheel ' + label,
          gems: gemsForPattern('pinwheel', accent),
        });
        patterns.push({
          id: 'all_inner_' + accent,
          label: 'All ' + label + ' Inner',
          gems: gemsForPattern('all_inner', accent),
        });
        patterns.push({
          id: 'all_outer_' + accent,
          label: 'All ' + label + ' Outer',
          gems: gemsForPattern('all_outer', accent),
        });
        patterns.push({
          id: 'alt_inner_' + accent,
          label: 'Alternating ' + label + ' Inner',
          gems: gemsForPattern('alt_inner', accent),
        });
        patterns.push({
          id: 'alt_outer_' + accent,
          label: 'Alternating ' + label + ' Outer',
          gems: gemsForPattern('alt_outer', accent),
        });
      } else if (!fourX) {
        patterns.push({
          id: 'alt_' + accent,
          label: 'Alternating ' + label,
          gems: gemsForPattern('alt', accent, 'white'),
        });
        if (groupCount >= 4) {
          patterns.push({
            id: 'x_' + accent,
            label: 'X — ' + label,
            gems: gemsForPattern('x', accent),
          });
        }
      }
    });

    if (list.length >= 2) {
      var a = list[0];
      var b = list[1];
      var la = gemLabel(a);
      var lb = gemLabel(b);
      if (is177) {
        patterns.push({
          id: 'pinwheel_' + a + '_' + b,
          label: 'Pinwheel ' + la + ' / ' + lb,
          gems: gemsForPattern('pinwheel_2', a, b),
        });
        patterns.push({
          id: 'all_inner_' + a + '_outer_' + b,
          label: 'All ' + la + ' Inner / All ' + lb + ' Outer',
          gems: gemsForPattern('all_inner_outer', a, b),
        });
        patterns.push({
          id: 'alt_inner_' + a + '_' + b,
          label: 'Alternating ' + la + ' / ' + lb + ' Inner',
          gems: gemsForPattern('alt_inner_2', a, b),
        });
        patterns.push({
          id: 'alt_outer_' + a + '_' + b,
          label: 'Alternating ' + la + ' / ' + lb + ' Outer',
          gems: gemsForPattern('alt_outer_2', a, b),
        });
      } else if (fourX) {
        patterns.push({
          id: 'alt_x_' + a + '_' + b,
          label: 'Alternating X — ' + la + ' / ' + lb,
          gems: gemsForPattern('alt_x', a, b),
        });
        patterns.push({
          id: 'alt_x_' + b + '_' + a,
          label: 'Alternating X — ' + lb + ' / ' + la,
          gems: gemsForPattern('alt_x', b, a),
        });
        patterns.push({
          id: 'alt_' + a + '_' + b,
          label: 'Alternating ' + la + ' / ' + lb,
          gems: gemsForPattern('alt', a, b),
        });
        patterns.push({
          id: 'alt_' + b + '_' + a,
          label: 'Alternating ' + lb + ' / ' + la,
          gems: gemsForPattern('alt', b, a),
        });
      } else {
        patterns.push({
          id: 'alt_' + a + '_' + b,
          label: 'Alternating ' + la + ' / ' + lb,
          gems: gemsForPattern('alt', a, b),
        });
        if (groupCount >= 4) {
          patterns.push({
            id: 'alt_x_' + a + '_' + b,
            label: 'Alternating X — ' + la + ' / ' + lb,
            gems: gemsForPattern('alt_x', a, b),
          });
        }
      }
    }

    return patterns;
  }

  /* -------------------------------------------------------------------------- */
  /* Apply to Thinkspace Groups (clean — no popovers)                           */
  /* -------------------------------------------------------------------------- */

  function groupFields() {
    return Array.from(
      document.querySelectorAll('[data-option^="Group "]')
    ).filter(function (el) {
      return /^Group \d+$/.test(el.getAttribute('data-option') || '');
    });
  }

  function groupsGrid() {
    var g1 = document.querySelector('[data-option="Group 1"]');
    return g1 ? g1.parentElement : null;
  }

  function resolveGemObject(value) {
    var v = value || 'white';
    var w = B.controller();
    var list = (w && w.COLORS && w.COLORS.GEMS) || gemCatalog();
    for (var i = 0; i < list.length; i++) {
      if (list[i].value === v) return list[i];
    }
    return { label: gemLabel(v), value: v, hex: '#ccc' };
  }

  function applyGems(gemValues) {
    var w = B.controller();
    var wiz = B.wizard();
    if (!w || !Array.isArray(w.gemstone_colors) || !w.gemstone_colors.length) {
      return false;
    }

    // Same write a Group swatch tap makes, so Thinkspace's own iframe update
    // effect fires. Do not replace the array or post to the viewer directly —
    // the picker's data:change:iframe handler transforms part2/sealTone2 before
    // posting, and a raw message would drop that.
    var count = w.gemstone_colors.length;
    for (var i = 0; i < count; i++) {
      var obj = resolveGemObject(gemValues[i] || 'white');
      w.gemstone_colors[i] = obj;
      if (wiz && typeof wiz.setFieldValue === 'function') {
        wiz.setFieldValue('gemstone_colors[' + i + ']', {
          touched: true,
          valid: true,
          value: obj.value,
        });
      }
    }
    return true;
  }

  /* -------------------------------------------------------------------------- */
  /* UI                                                                         */
  /* -------------------------------------------------------------------------- */

  function stateFor(panel) {
    return (
      panel._sjGemState ||
      (panel._sjGemState = { patternIndex: 0, patterns: [] })
    );
  }

  function currentGemValues() {
    var w = B.controller();
    if (!w || !Array.isArray(w.gemstone_colors)) return [];
    return w.gemstone_colors.map(function (g) {
      return (g && g.value) || 'white';
    });
  }

  function gemsMatch(patternGems, current, count) {
    var n = count || current.length || 0;
    for (var i = 0; i < n; i++) {
      if ((patternGems[i] || 'white') !== (current[i] || 'white')) return false;
    }
    return n > 0;
  }

  function rematchPatternIndex(state) {
    var gems = currentGemValues();
    if (!gems.length || !state.patterns.length) return;
    for (var i = 0; i < state.patterns.length; i++) {
      if (gemsMatch(state.patterns[i].gems, gems, gems.length)) {
        state.patternIndex = i;
        return;
      }
    }
  }

  function rebuildPatterns(state, rematch) {
    state.patterns = buildPatterns(schoolAccents());
    if (state.patternIndex >= state.patterns.length) state.patternIndex = 0;
    if (rematch) rematchPatternIndex(state);
  }

  function currentPattern(state) {
    return state.patterns[state.patternIndex] || state.patterns[0] || null;
  }

  function updatePatternChrome(panel) {
    var state = stateFor(panel);
    rebuildPatterns(state);
    var pat = currentPattern(state);
    var labelEl = panel.querySelector('[data-sj-gem-pattern-label]');
    if (labelEl) labelEl.textContent = pat ? pat.label : 'All White';
    var len = state.patterns.length;
    panel.querySelectorAll('.sj-gem-pattern__btn').forEach(function (btn) {
      btn.disabled = len <= 1;
    });
  }

  function bindPatternNav(panel) {
    var state = stateFor(panel);
    var row = panel.querySelector('.sj-gem-pattern');
    var prev = panel.querySelector('[data-sj-gem-prev]');
    var next = panel.querySelector('[data-sj-gem-next]');
    if (!prev || !next || !row || prev._sjBound) return;
    prev._sjBound = true;
    next._sjBound = true;

    function step(delta) {
      rebuildPatterns(state);
      var len = state.patterns.length;
      if (len <= 1) return;
      state.patternIndex = (state.patternIndex + delta + len) % len;
      var p = currentPattern(state);
      if (p) applyGems(p.gems);
      updatePatternChrome(panel);
    }

    var lastNavAt = 0;
    function onNav(delta, e) {
      if (e) {
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
      }
      var now = Date.now();
      if (now - lastNavAt < 280) return;
      lastNavAt = now;
      step(delta);
    }

    function bindBtn(btn, delta) {
      btn.addEventListener('click', function (e) {
        onNav(delta, e);
      });
      btn.addEventListener(
        'touchend',
        function (e) {
          onNav(delta, e);
        },
        { passive: false }
      );
    }
    bindBtn(prev, -1);
    bindBtn(next, 1);

    var startX = null;
    var startY = null;
    row.addEventListener(
      'touchstart',
      function (e) {
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        startX = t.clientX;
        startY = t.clientY;
      },
      { passive: true }
    );
    row.addEventListener(
      'touchend',
      function (e) {
        if (e.target && e.target.closest && e.target.closest('.sj-gem-pattern__btn')) {
          startX = null;
          startY = null;
          return;
        }
        var t = e.changedTouches && e.changedTouches[0];
        if (!t || startX == null) return;
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        startX = null;
        startY = null;
        if (Math.abs(dx) > 32 && Math.abs(dx) > Math.abs(dy)) {
          onNav(dx < 0 ? 1 : -1, e);
        }
      },
      { passive: false }
    );
  }

  function looksLikeGemPopover(el) {
    if (!el || !el.querySelector) return false;
    var text = String(el.textContent || '').toLowerCase();
    if (text.indexOf('white') === -1 && text.indexOf('ruby') === -1) return false;
    var dots = el.querySelectorAll('[class*="rounded-full"]');
    return dots.length >= 3;
  }

  function closeGemPopover() {
    var open = document.querySelector(
      '[data-option^="Group "] [aria-expanded="true"], [data-option^="Group "] [data-state="open"]'
    );
    if (open) {
      open.click();
      return;
    }
    document.dispatchEvent(
      new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true })
    );
  }

  function findGemPopovers() {
    var found = [];
    var seeds = document.querySelectorAll(
      '[role="listbox"], [data-select-content], [data-bits-select-content], [data-melt-select-content]'
    );
    var i;
    for (i = 0; i < seeds.length; i++) {
      if (looksLikeGemPopover(seeds[i]) && found.indexOf(seeds[i]) === -1) {
        found.push(seeds[i]);
      }
    }
    if (found.length) return found;
    var dots = document.querySelectorAll('[class*="rounded-full"]');
    for (i = 0; i < dots.length; i++) {
      var p = dots[i].parentElement;
      var hops = 0;
      while (p && p !== document.body && hops < 6) {
        if (looksLikeGemPopover(p) && found.indexOf(p) === -1) found.push(p);
        p = p.parentElement;
        hops += 1;
      }
    }
    return found;
  }

  function decorateGemPopovers() {
    var nodes = findGemPopovers();
    for (var i = 0; i < nodes.length; i++) {
      var box = nodes[i];
      if (box.querySelector('.sj-gem-popover-close')) continue;
      box.classList.add('sj-gem-color-popover');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sj-gem-popover-close';
      btn.setAttribute('aria-label', 'Close color picker');
      btn.textContent = '×';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeGemPopover();
      });
      box.appendChild(btn);
    }
  }

  function bindGemPopoverClose() {
    if (document.documentElement.hasAttribute('data-sj-gem-popover-close')) return;
    document.documentElement.setAttribute('data-sj-gem-popover-close', '');
    document.addEventListener(
      'click',
      function () {
        setTimeout(decorateGemPopovers, 30);
      },
      true
    );
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        decorateGemPopovers();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function renderPanel(panel) {
    var state = stateFor(panel);
    rebuildPatterns(state);

    var groups = groupFields();
    if (!groups.length) {
      panel.hidden = true;
      return;
    }
    panel.hidden = false;

    var pat = currentPattern(state);
    var len = state.patterns.length;

    if (!panel.querySelector('.sj-gem-pattern')) {
      panel.innerHTML =
        '<div class="sj-gem-auto">' +
        '<div class="sj-gem-pattern" role="group" aria-label="Stone pattern">' +
        '<button type="button" class="sj-gem-pattern__btn" data-sj-gem-prev aria-label="Previous stone pattern">' +
        SVG_PREV +
        '</button>' +
        '<span class="sj-gem-pattern__text">Stone Pattern: <span data-sj-gem-pattern-label></span></span>' +
        '<button type="button" class="sj-gem-pattern__btn" data-sj-gem-next aria-label="Next stone pattern">' +
        SVG_NEXT +
        '</button>' +
        '</div></div>';
      bindPatternNav(panel);
    }

    var labelEl = panel.querySelector('[data-sj-gem-pattern-label]');
    if (labelEl) labelEl.textContent = pat ? pat.label : 'All White';
    panel.querySelectorAll('.sj-gem-pattern__btn').forEach(function (btn) {
      btn.disabled = len <= 1;
    });
  }

  function ensurePanel() {
    var groups = groupFields();
    if (!groups.length) return null;

    var grid = groupsGrid();
    var existing = document.querySelector('[' + HOST_ATTR + ']');

    if (existing) {
      if (grid && (existing.parentElement !== grid || grid.firstChild !== existing)) {
        grid.insertBefore(existing, grid.firstChild);
      }
      return existing;
    }

    var panel = document.createElement('div');
    panel.setAttribute(HOST_ATTR, '');
    panel.className = 'sj-gem-panel-host';
    if (grid) grid.insertBefore(panel, grid.firstChild);
    else groups[0].before(panel);
    return panel;
  }

  function sync() {
    var panel = ensurePanel();
    if (!panel) return;

    var state = stateFor(panel);
    var prevKey = panel.getAttribute('data-sj-gem-key') || '';
    var key = [gemMapKey(), schoolName(), groupFields().length].join('|');
    if (prevKey !== key) {
      panel.setAttribute('data-sj-gem-key', key);
      rebuildPatterns(state, true);
    }
    renderPanel(panel);
  }

  /* -------------------------------------------------------------------------- */
  /* Boot                                                                       */
  /* -------------------------------------------------------------------------- */

  B.bootOnWidget(function (widget) {
    var watch = B.watchWidget(widget, sync);
    bindGemPopoverClose();
    document.addEventListener('sj-school-colors-ready', function () {
      watch.schedule();
    });

    widget.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var field = t.closest('[data-option]');
        if (!field) return;
        var name = field.getAttribute('data-option') || '';
        if (
          name === 'Ring Style' ||
          name === 'Pendant Style' ||
          name === 'Seal Size' ||
          name === 'School'
        ) {
          watch.schedule();
        }
      },
      true
    );
  });
})();
